<div class="ontario-row">
  <div class="ontario-column ontario-small-12 search-criteria-tablet-container">
    <button class="menu" (click)="openDialog(filterDialog)">
      <img src="assets/images/ic_tune.svg" alt="Open">
      Filters
    </button>
    <button class="menu sort-button" (click)="openDialog(sortDialog)">
      <img src="assets/images/ic_sort.svg" alt="Open">
      Sort
    </button>
  </div>
</div>
<div class="ontario-column ontario-small-12 grey-background">
  <ng-template #filterDialog>
    <div class="search-criteria-tablet-container padding-top-0 grey-background" style="margin-left: 0;">
      <div class="dialog-header">
        <div class="float-left inline-block close-icon" (click)="closeDialog()"></div>
        <div class="inline-block">Filter</div>
        <div class="float-right inline-block">
          <button type="button" class="ontario-button ontario-button--tertiary plain-button"
            (click)="initSearchForm(); closeDialog()">
            Reset
          </button>
        </div>
      </div>

      @if (!isClassNotification && isUserAdminOrDSA) {
        <div class="ontario-row ontario-padding-top-48-!">
          <div class="ontario-column form-input-div ontario-small-12">
            <app-dropdown [label]="'NotificationSearch.Category' | translate" [currentLang]="currentLang"
              [(formValue)]="notificationSearchForm.category" [options]="notificationCategoriesForAdminOrDSA">
            </app-dropdown>
          </div>
        </div>
      }

      @if (!isClassNotification && !isUserAdminOrDSA) {
        <div class="ontario-row ontario-padding-top-48-!">
          <div class="ontario-column form-input-div ontario-small-12">
            <app-dropdown [label]="'NotificationSearch.Category' | translate" [currentLang]="currentLang"
              [(formValue)]="notificationSearchForm.category" [options]="notificationCategoriesForNonAdminOrDSA">
            </app-dropdown>
          </div>
        </div>
      }

      <!-- Dates -->
      <div class="ontario-row padding-top-15rem">
        <div class="ontario-column form-input-div ontario-small-12">
          <label class="input-label">{{'General.FromDate' | translate}}</label>
          <input type="date" [max]="notificationSearchForm.toDate| date : 'yyyy-MM-dd'"
            [ngModel]="notificationSearchForm.fromDate | date : 'yyyy-MM-dd'" (ngModelChange)="StartDateChange($event)"
            class="ontario-date-input start-date ng-untouched ng-pristine ng-valid">
          </div>
        </div>

        <div class="ontario-row padding-top-15rem">
          <div class="ontario-column form-input-div ontario-small-12">
            <label class="input-label">{{'General.ToDate' | translate}}</label>
            <input type="date" [min]="notificationSearchForm.fromDate| date : 'yyyy-MM-dd'"
              [ngModel]="notificationSearchForm.toDate | date : 'yyyy-MM-dd'" (ngModelChange)="EndDateChange($event)"
              class="ontario-date-input start-date ng-untouched ng-pristine ng-valid">
            </div>
          </div>

          @if (!ValidStartandEndDate()) {
            <div class="ontario-row padding-top-15rem">
              <mat-error>
                {{'TrainingSchedules.OneDateisRequired' | translate}}
              </mat-error>
            </div>
          }

          <div class="ontario-row ontario-padding-top-48-!">
            <div class="ontario-column form-input-div ontario-small-12">
              <app-horizontal-radio-button-list [label]="'NotificationSearch.Show' | translate" [currentLang]="currentLang"
                [(value)]="notificationSearchForm.notificationStatus" [radioButtonOptions]="notificationStatuses">
              </app-horizontal-radio-button-list>
            </div>
          </div>

          <div class="ontario-row ontario-padding-top-16-! text-in-middle ontario-padding-bottom-48-!">
            <div class="ontario-column form-input-div ontario-small-12 margin-top-1">
              <button class="search-button" (click)="performSearch()">
                Apply
              </button>
            </div>
          </div>

        </div>
      </ng-template>
      <ng-template #sortDialog>
        <div class="search-criteria-tablet-container padding-top-0 grey-background height-100-perc">
          <div class="dialog-header">
            <div class="float-left inline-block close-icon" (click)="closeDialog()"></div>
            <div class="inline-block">Sort</div>
          </div>
          <div class="ontario-row ontario-padding-top-48-!">
            <div class="ontario-column form-input-div ontario-small-12 float-left">
              <div class="other-group-buttons">
                <label for="sortBy" id="sort-by-label">
                  {{ 'TrainingProgramSearch.SortBy' | translate }}
                  <app-tooltip [tooltipText]="'TrainingProgramSearch.SortBy' | translate" tabindex="-1">
                    {{ 'TrainingProgramSearch.SortBy' | translate }}
                  </app-tooltip>
                </label>
                <app-radio-button-list aria-labelledby="sort-by-label" [currentLang]="currentLang"
                  [(selectedValue)]="notificationSearchForm.sortingOption" [radioButtonOptions]="sortingOptions">
                </app-radio-button-list>
              </div>
            </div>
          </div>
          <div class="ontario-row ontario-padding-top-48-!">
            <div class="ontario-column form-input-div ontario-small-12 margin-top-1">
              <button class="search-button" (click)="performSearch()">
                Apply
              </button>
            </div>
          </div>
        </div>
      </ng-template>
    </div>

    <div class="search-criteria-container desktop-only">

      <div class="ontario-row">
        @if (!isClassNotification && isUserAdminOrDSA) {
          <div class="ontario-column form-input-div ontario-small-3">
            <app-dropdown [label]="'NotificationSearch.Category' | translate" [currentLang]="currentLang"
              [(formValue)]="notificationSearchForm.category" [options]="notificationCategoriesForAdminOrDSA">
            </app-dropdown>
          </div>
        }
        @if (!isClassNotification && !isUserAdminOrDSA) {
          <div class="ontario-column form-input-div ontario-small-3">
            <app-dropdown [label]="'NotificationSearch.Category' | translate" [currentLang]="currentLang"
              [(formValue)]="notificationSearchForm.category" [options]="notificationCategoriesForNonAdminOrDSA">
            </app-dropdown>
          </div>
        }
        <div class="ontario-column form-input-div" [ngClass]="isClassNotification ? 'ontario-small-3': 'ontario-small-2'">
          <app-dropdown [label]="'NotificationSearch.SortBy' | translate" [currentLang]="currentLang"
            [(formValue)]="notificationSearchForm.sortingOption" [options]="sortingOptions">
          </app-dropdown>
        </div>
        <div class="ontario-column form-input-div ontario-small-3">
          <app-date-range [(startDate)]="notificationSearchForm.fromDate!" [(endDate)]="notificationSearchForm.toDate!"
          [minStartDate]="minStartDate" [disableIfNoStartDate]="false"></app-date-range>
        </div>
        <div class="ontario-column form-input-div ontario-small-4">
          <app-horizontal-radio-button-list [label]="'NotificationSearch.Show' | translate" [currentLang]="currentLang"
            [(value)]="notificationSearchForm.notificationStatus" [radioButtonOptions]="notificationStatuses">
          </app-horizontal-radio-button-list>
        </div>
      </div>
      <div class="ontario-row">
        <!--TO-DO: need to make sure behavior for isClassNotification flag in below line-->
        <div class="ontario-column" [ngClass]="isClassNotification ? 'ontario-small-12': 'ontario-small-12'">
          <button id="search-button" (click)="searchNotifications()">
            {{'NotificationSearch.Search'| translate}}
          </button>
          <button id="reset-button" (click)="initSearchForm()"
            class="ontario-button ontario-button--tertiary">
            {{'NotificationSearch.Reset' | translate}}
          </button>

        </div>
      </div>
    </div>